
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class ParticleFieldEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config } = pc;
        const spacing = (100 + layerIndex * 50) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing);
        const size = (2 + (config.parallaxLayers - layerIndex)) * (config.parallaxScale || 1.0);

        ctx.fillStyle = pc.color;

        for (let x = x1; x <= x2; x += spacing / 2) {
            for (let y = y1; y <= y2; y += spacing / 2) {
                const offX = this.pseudoRandom(x + layerIndex) * spacing;
                const offY = this.pseudoRandom(y + layerIndex) * spacing;
                const s = size * (0.2 + this.pseudoRandom(x * y) * 0.8);
                
                const draw = () => {
                    ctx.fillRect(x + offX, y + offY, s, s);
                };
                draw();
                this.applyGlow(pc, draw);
            }
        }
    }
}
